export default __webpack_public_path__ + "static/media/sc_pattern.2d334e55.png";